import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.css";
import FirstImage from "../../assets/images/SBM-CITIZEN-FEEDBACKSBM-logo.svg";
import SecondImage from "../../assets/images/SBM-CITIZEN-FEEDBACKCitizens-Graphic.svg";
import StarIcon from "../../assets/images/SBM-CITIZEN-FEEDBACKStar-icon.svg";
import MohuaLogo from "../../assets/images/SBM-CITIZEN-FEEDBACKMOHUA-Logo.svg";
import Button from "../../component/Button";
import ButtonOld from "../../component/ButtonOld";
import ButtonFirst from "../../component/ButtonFirst";

const Home = () => {
  const navigate = useNavigate();
  const onButtonClick = () => {
    navigate("/register");
  };

  useEffect(() => {
    localStorage.removeItem("login");
  }, []);
  return (
    <>
      <div className="container">
        <div className={styles.mainWrapper}>
          {/* <img src={FirstImage} alt="" />
          <img src={SecondImage} alt="emblem in between tricolor" /> */}
          <div className={styles.logoContainer}>
  <img
    src={MohuaLogo}
    alt="MOHUA"
    className={styles.ministryLogo}
  />
  <img 
    src={FirstImage} 
    alt="SBM Logo" 
    className={styles.topLogo} 
  />
</div>

          {/* Citizens Illustration */}
          <img
            src={SecondImage}
            alt="Citizens"
            className={styles.citizenImage}
          />
          {/* Stars + Heading */}
          <div className={styles.headingWrapper}>
            <img src={StarIcon} alt="star" className={styles.star} />

            <div className={styles.homePageHeading}>
              <p className={styles.swachh}>CITIZEN</p>
              <p className={styles.survey}>FEEDBACK</p>
            </div>

            <img src={StarIcon} alt="star" className={styles.star} />
          </div>

          {/* Year */}
          <p className={styles.year}>2026</p>


        </div>
        <div className={styles.bottomButtonWrapper}>
          <ButtonFirst text="Get Started" onClick={onButtonClick} disabled={false} />
        </div>

        {/* Ministry Logo */}
        {/* <img
          src={MohuaLogo}
          alt="MOHUA"
          className={styles.ministryLogo}
        /> */}
        {/* Footer */}
        <div className={styles.footerStrip}>
          Powered by Swachh Bharat Mission Urban
        </div>
      </div>
    </>
  );
};

export default Home;
